import { talents } from '../../services/apiService'
import HistoryTab from '../UI/HistoryTab'

const HistorySection = ({ talentId }) => (
  <div
    id="history"
    className="scroll-mt-40 overflow-hidden rounded-xl border border-light-border-primary bg-light-bg-primary dark:border-dark-border-primary dark:bg-dark-bg-primary min-[992px]:scroll-mt-20"
  >
    <HistoryTab
      entityId={talentId}
      fetchEventsFunction={talents.getTalentEvents}
      fetchStatsFunction={talents.getTalentEventStats}
    />
  </div>
)

export default HistorySection
